import * as React from 'react';
import { useNavigate } from "react-router-dom";

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { SYSTEM_PATH_COMPANY, SYSTEM_PATH_CUSTOMER } from "../App";
import { postLoginAPI } from "../http/api/AuthorityAPI";
import { isNullEmpty } from "../utils/validation";
import { MSG_ERR_UNEXPECTED, MSG_ERR_LOGIN_INFO_NOT_ENTERED, MSG_ERR_LOGIN } from "../common/message";
import { encrypt } from '../utils/crypto';

const theme = createTheme();

/**
 * コピーライト取得
 */
function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://sic-group.jp/">
        SIC GROUP. All Rights Reserved.
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

/**
 * ログイン処理
 */
export default function SignIn() {

  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    // 必須項目チェック
    if (isNullEmpty(data.get('loginId')) || isNullEmpty(data.get('userPassword'))) {
      // 必須項目未入力エラー @TODO 仮処理
      alert(MSG_ERR_LOGIN_INFO_NOT_ENTERED);
      return;
    }
    
    // ログイン認証を実行
    let api = postLoginAPI({loginId: data.get('loginId'), userPassword: data.get('userPassword')});
    api.then(response => {

      let token = response.token;
      let userInfo = JSON.stringify(response.userInfo);
      let userTypeCd = response.userInfo.userTypeCd;
      let customerId = response.userInfo.shopId;

      // トークンの保持
      sessionStorage.setItem('token', token);

      // ユーザー情報の保持(暗号化)
      sessionStorage.setItem('userInfo', encrypt(userInfo));

      // ログイン情報
      let loginInfo = {
        token: token,
        userInfo: JSON.parse(userInfo)
      };

      // 認証に成功した場合はトップ画面に遷移
      if (userTypeCd === 1) {
        navigate(SYSTEM_PATH_COMPANY + '/home');
      } else {
        navigate(SYSTEM_PATH_CUSTOMER + '/order_edit', { 'customerId': customerId });
      }
    }).catch((error) => {
      // 認証に失敗した場合はエラー表示 @TODO 仮処理
      alert(MSG_ERR_LOGIN);
    }).catch((error) => {
      // 認証に失敗した場合はエラー表示 @TODO 仮処理
      alert(MSG_ERR_UNEXPECTED);
    });
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            青果卸売管理システム - ISeika -
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="loginId"
              label="ログインID"
              name="loginId"
              autoComplete="loginId"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="userPassword"
              label="パスワード"
              type="password"
              id="userPassword"
              autoComplete="current-password"
            />
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="ログイン状態を保持する。"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              ログイン
            </Button>
            <Grid container>
              {/* <Grid item xs>
                <Link href="company/basic_price" variant="body2">
                  お忘れの方はこちら
                </Link>
              </Grid> */}
              {/* <Grid item>
                <Link href="customer/order_edit" variant="body2">
                  {"取引先用ページ"}
                </Link>
              </Grid> */}
            </Grid>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}